import React from "react";

const OauthToken = (props: any) => {
    const baseUrl = `${window.location.origin}`;
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const email = urlParams.get('email');
    const picture = urlParams.get('picture');
    const name = urlParams.get('name');
    window.opener.postMessage({ token, email, picture, name }, baseUrl);
    window.close();
    return (
        <div>
            Succesfull
        </div>
    )
}

export default OauthToken;